import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pay-content" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "flex-cen-ter" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "dialog-title-content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "pay-container" }
const _hoisted_10 = { class: "pay-content-price" }
const _hoisted_11 = { class: "pay-content-price-title" }
const _hoisted_12 = { class: "pay-content-price-content" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "sign-up-num"
}
const _hoisted_15 = { class: "abs pay-content-price-item-box flex-col-aistart" }
const _hoisted_16 = {
  key: 0,
  class: "trialPrice"
}
const _hoisted_17 = {
  key: 1,
  class: "price"
}
const _hoisted_18 = { class: "cut-price" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 2,
  class: "active-cut flex-cen-ter"
}
const _hoisted_21 = {
  key: 3,
  class: "active-newMember flex-cen-ter"
}
const _hoisted_22 = { class: "pay-content-way" }
const _hoisted_23 = { class: "pay-content-way-title" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "tip" }
const _hoisted_26 = { class: "pay-way-content" }

import { t } from '@/plugins/i18n'
import { ref, computed, onMounted } from 'vue'
import { ArrowRight, CloseBold } from '@element-plus/icons-vue'
import PayWay from './PayWay.vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import { Site } from '@/common/const'
import { formatCountryMoney, getCurrentMonetaryUnit, formatMoneyDirection } from '@/util/useYan'
import { isEN, isJA, isKO, useSite } from '@/store'
import { formatMoney } from '@/plugins/utils'
import { promotionPluginFnMember } from '@/views/signup/util'
import { membershipIsFirst } from '@/apis/membership'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'success', 'error'],
  setup(__props, { expose, emit }) {

const props = __props
const store = useStore()

const userInfo = computed(() => {
  return store.getters.user
})

const titleBgImages = [
  '',
  'https://static-s.theckb.com/BusinessMarket/member/popup_header_level_1.png',
  'https://static-s.theckb.com/BusinessMarket/member/popup_header_level_2.png',
  'https://static-s.theckb.com/BusinessMarket/member/popup_header_level_3.png',
  'https://static-s.theckb.com/BusinessMarket/member/popup_header_level_4.png',
  'https://static-s.theckb.com/BusinessMarket/member/popup_header_level_5.png'
]
const levelIconImages = [
  '',
  require('@/assets/image/vipImg/badge_economy_simple.png'),
  require('@/assets/image/vipImg/badge_standard_simple.png'),
  require('@/assets/image/vipImg/badge_business_simple.png'),
  require('@/assets/image/vipImg/badge_first_simple.png'),
  require('@/assets/image/vipImg/badge_special_simple.png')
]
const templatePriceIconImages = [
  '',
  require('@/assets/image/vipImg/popup_economy_pay_select.png'),
  require('@/assets/image/vipImg/popup_standard_pay_select.png'),
  require('@/assets/image/vipImg/popup_business_pay_select.png'),
  require('@/assets/image/vipImg/popup_first_pay_select.png'),
  require('@/assets/image/vipImg/popup_special_pay_select.png')
]


const close = () => {
  emit('update:visible', false)
}

// TODO:根据用户信息判断是哪个站点。当前默认为日本站点
const isJapan = ref(false)
const isKorea = ref(false)
const isEnglish = ref(false)

onMounted(() => {
  if (isJA()) {
    isJapan.value = true
  } else if (isKO()) {
    isKorea.value = true
  } else {
    isEnglish.value = true
  }
})

const vipInfo = ref<any>({})
const checkValue = ref(1)
const activeVip = ref<any>({})

const getPriceToFixed = (price: number): number => {
  return Number(price.toFixed(2))
}
const open = (info: any) => {
  info = { ...info }
  info.vipInfo.priceItemList = info.vipInfo.priceItemList.filter((i: any) => i.trialFlag || info.vipInfo.priceItemList.filter((y: any) => y.trialFlag).every((v: any) => v.validPeriod !== i.validPeriod))
  info.vipInfo.priceItemList.map((item: any) => {
    // 折合56円/月
    item.averagePrice = isEN() ? (item.discountActualPrice / item.validPeriod * 30).toFixed(2) : (item.discountActualPrice / item.validPeriod * 30).toFixed(0)
    // 折扣
    item.cut = (((item.discountActualPrice / item.validPeriod * 30) / (info.vipInfo.priceItemList[0].discountActualPrice / info.vipInfo.priceItemList[0].validPeriod * 30)) * 100).toFixed(0)
    item.cut = 100 - parseInt(item.cut)
    console.log(info.vipInfo.priceItemList[0].discountActualPrice / info.vipInfo.priceItemList[0].validPeriod * item.validPeriod + 'sss---' + item.discountActualPrice, 'sss')
    // 优惠金额
    // 试用活动取trialPrice
    item.finalDiscountPrice = getPriceToFixed(info.vipInfo.priceItemList[0].discountActualPrice / info.vipInfo.priceItemList[0].validPeriod * item.validPeriod) - (item.trialFlag ? item.trialPrice : item.discountActualPrice)
    item.newMemberTag = t('新限量')
  })
  console.log(info.vipInfo)
  vipInfo.value = info.vipInfo
  checkValue.value = info.checkValue
  const newMemberItem = info.vipInfo.priceItemList.filter((v: any) => v.trialFlag)
  activeVip.value = newMemberItem.length ? newMemberItem[0] : info.vipInfo.priceItemList[0]
}
const changePrice = (item: any) => {
  activeVip.value = item
}
const timeStr = computed(() => {
  let str = ''
  if (checkValue.value === 2 || (userInfo.value.membership.templateLevel >= vipInfo.value.templateLevel)) {
    // 到期续费 用户到期时间加1 -有效时长
    str = dayjs(userInfo.value.membership.expiresDate).add(1, 'day').format('YYYY-MM-DD') + ' - ' + dayjs(userInfo.value.membership.expiresDate).add(activeVip.value.validPeriod, 'day').format('YYYY-MM-DD')
  } else {
    str = dayjs().format('YYYY-MM-DD') + ' - ' + dayjs().add(activeVip.value.validPeriod, 'day').format('YYYY-MM-DD')
  }
  return str
})
expose({
  open
})
const paySuccess = (type: any) => {
  emit('success', {
    title: checkValue.value === 2 ? t('已成功开通预充会员') : t('已成功开通会员'),
    text: checkValue.value === 2 ? t('已为您开启预充会员V，有效期为Y').replace('V', `<span style="color:#EB4545;">【${activeVip.value.priceName}】</span>`).replace('Y', `<span style="color:#EB4545;">${timeStr.value}</span>`) : t('已为您开启V，有效期为Y').replace('V', `<span style="color:#EB4545;">【${activeVip.value.priceName}】</span>`).replace('Y', `<span style="color:#EB4545;">${timeStr.value}</span>`),
    isPaypal: !!type
  })
  // membershipIsFirst().then(res => {
  //   // console.log(res, userInfo)

  //   function checkoutTime (res: any) {
  //     // 充值时间小于48小时
  //     return new Date(res.data.rechargeTime).getTime() - new Date(res.data.registerTime).getTime() < (3600000 * 48)
  //   }
  //   if (res.data.isFirstRecharge && res.data?.level < 2 && checkoutTime(res)) {
  //     console.log('需要上报')
  //     // 先不做 注释掉
  //     // promotionPluginFnMember({
  //     //   ...res.data,
  //     //   ...userInfo.value
  //     // })
  //   }
  // })
}
const errorPay = () => {
  emit('error')
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": `pay-content-dialog ${vipInfo.value.templateLevel === 5 ? 'spacial' : ''}`,
      "model-value": __props.visible,
      onClose: close,
      "append-to-body": "",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "dialog-title flex-bwn",
            style: _normalizeStyle(`background-image:url(${titleBgImages[vipInfo.value.templateLevel ?? 0]})`)
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "levelIcon",
                src: levelIconImages[vipInfo.value.templateLevel],
                alt: ""
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(vipInfo.value.priceName), 1),
                  (checkValue.value === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（" + _toDisplayString(_unref(t)('定时升舱')) + "）", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('有效期')) + "：" + _toDisplayString(_unref(timeStr)), 1)
              ])
            ]),
            _createVNode(_component_el_icon, {
              class: "icon-close",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CloseBold))
              ]),
              _: 1
            })
          ], 4),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('利用期间')), 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipInfo.value.priceItemList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass('pay-content-price-item pay-content-price-item' + vipInfo.value.templateLevel + (item.membershipTemplatePriceId === activeVip.value.membershipTemplatePriceId ? ' active' : '')),
                    key: index,
                    onClick: ($event: any) => (changePrice(item))
                  }, [
                    (item.trialFlag && item.limitedQuantityStatus && vipInfo.value.templateLevel === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('名额仅剩X名').replace('X',
                    item.lastQuantity)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["month", _unref(useSite)()])
                      }, _toDisplayString((item.validPeriod / 30).toFixed(0)) + _toDisplayString(_unref(t)('ヶ月')), 3),
                      (item.trialFlag)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.trialPrice ?
                    _unref(formatMoneyDirection)(item.trialPrice, isJapan.value)
                    : _unref(formatCountryMoney)(0)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.discountActualPrice ?
                    _unref(formatMoneyDirection)(item.discountActualPrice, isJapan.value) :
                    ''), 1)),
                      _createElementVNode("div", _hoisted_18, [
                        (item.discountPrice && !item.basicFlag)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(_unref(formatMoneyDirection)(item.discountPrice, isJapan.value)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.cut > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(item.cut) + _toDisplayString(_unref(t)('%off')), 1))
                        : _createCommentVNode("", true),
                      (item.trialFlag)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(t)(item.newMemberTag)), 1))
                        : _createCommentVNode("", true),
                      (!item.basicFlag && !item.trialFlag)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            class: _normalizeClass(["compute-price", _unref(useSite)()])
                          }, _toDisplayString(_unref(t)('折合X円/月').replace('X',
                      _unref(formatMoney)(item.averagePrice, isJapan.value))), 3))
                        : _createCommentVNode("", true),
                      (!item.basicFlag && item.trialFlag)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 5,
                            class: _normalizeClass(["compute-price", _unref(useSite)()])
                          }, _toDisplayString(_unref(t)('次月续费X円/月').replace('X',
                      _unref(formatMoney)(item.discountActualPrice, isJapan.value))), 3))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('支付方式')), 1),
                _createElementVNode("span", _hoisted_25, "* " + _toDisplayString(_unref(t)('购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (__props.visible)
                ? (_openBlock(), _createBlock(PayWay, {
                    key: 0,
                    isJapan: isJapan.value,
                    isEnglish: isEnglish.value,
                    isKorea: isKorea.value,
                    templateLevel: vipInfo.value.templateLevel,
                    vipInfo: vipInfo.value,
                    activeVip: activeVip.value,
                    checkValue: checkValue.value,
                    onSuccess: paySuccess,
                    onError: errorPay
                  }, null, 8, ["isJapan", "isEnglish", "isKorea", "templateLevel", "vipInfo", "activeVip", "checkValue"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["custom-class", "model-value"])
  ]))
}
}

})